<div class="field col-12">
    <label>{{pergunta.detalhesTitulo}}</label>
    <p-multiSelect [options]="pergunta.detalhesOpcoes" appendTo="body" [(ngModel)]="pergunta.resposta"
        [disabled]="!habilitado" (ngModelChange)="respostaAlterada()"></p-multiSelect>
</div>